import ConfirmationModalView from './ConfirmationModalView';
export default ConfirmationModalView;
